import { render, staticRenderFns } from "./StockProduct.vue?vue&type=template&id=2db3cd2c&"
import script from "./StockProduct.vue?vue&type=script&lang=js&"
export * from "./StockProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports